import { AuditLogAction } from "@myapp/contract";

export const auditLogActionLabels: Record<AuditLogAction, string> = {
  WORK_ORDER_CREATED: 'Auftrag erfasst',
  WORK_ORDER_STATUS_CHANGED: 'Auftrag aktualisiert',
  WORK_ORDER_COMPLETED: 'Auftrag abgeschlossen',
  APPOINTMENT_CREATED: 'Termin geplant',
  APPOINTMENT_UPDATED: 'Termin bearbeitet',
  APPOINTMENT_RESCHEDULED: 'Termin umgeplant',
  APPOINTMENT_TECHNICIAN_CHANGED: 'Techniker geändert',
  APPOINTMENT_TRAVEL_STARTED: 'Anfahrt gestartet',
  APPOINTMENT_STARTED: 'Arbeit gestartet',
  APPOINTMENT_DEPARTURE_COMPLETED: 'Abfahrt beendet',
  APPOINTMENT_TIMES_CORRECTED: 'Zeiten angepasst',
  APPOINTMENT_PHASE_REVERTED: 'Schritt zurückgenommen',
  APPOINTMENT_COMPLETED: 'Termin abgeschlossen',
  APPOINTMENT_FOLLOW_UP_REQUESTED: 'Folgetermin erforderlich',
  APPOINTMENT_EXPIRED: 'Termin abgelaufen',
  APPOINTMENT_SERIES_UPDATED: 'Serientermin aktualisiert',
  APPOINTMENT_SERIES_EXTENDED: 'Serie verlängert',
  APPOINTMENT_SERIES_SHORTENED: 'Serie verkürzt',
  APPOINTMENT_DETACHED_FROM_SERIES: 'Aus Serie gelöst',
  APPOINTMENT_DELETED: 'Termin gelöscht',
  TASK_TRAVEL_STARTED: 'Anfahrt gestartet',
  TASK_STARTED: 'Arbeit gestartet',
  TASK_DEPARTURE_COMPLETED: 'Abfahrt beendet',
  TASK_TIMES_CORRECTED: 'Zeiten angepasst',
  TASK_PHASE_REVERTED: 'Schritt zurückgenommen',
  TASK_COMPLETED: 'Aufgabe abgeschlossen',
  TASK_RESCHEDULED: 'Aufgabe umgeplant',
  TASK_UPDATED: 'Aufgabe bearbeitet',
  TASK_DELETED: 'Aufgabe gelöscht',
  TASK_SERIES_EXTENDED: 'Aufgabenserie verlängert',
  TASK_SERIES_SHORTENED: 'Aufgabenserie verkürzt',
  TASK_DETACHED_FROM_SERIES: 'Aufgabe aus Serie gelöst',
};
